import React from 'react';
import SpotlightCard from './SpotlightCard';
import '../styles/CongratulatoryNotification.css';

interface CongratulatoryNotificationProps {
  onClose: () => void;
}

const CongratulatoryNotification: React.FC<CongratulatoryNotificationProps> = ({ onClose }) => {
  return (
    <div className="congratulatory-overlay">
      <SpotlightCard
        className="congratulatory-card"
        spotlightColor="rgba(230, 126, 34, 0.4)"
      >
        <div className="congratulatory-content">
          <h2>Congratulations!</h2>
          <img
            src="/graphics/Main LOGO 1 transparent.png"
            alt="SpitFire Logo"
            className="congratulatory-logo"
          />
          <div className="congratulatory-text-container">
            <p>You're one of our first 50 positive reviewers!</p>
            <p>Thank you for your support and kind words. We're thrilled to have you as one of our early supporters.</p>
            <p>As a token of our appreciation, please mention this notification at your next SpitFire Catering event for a special surprise!</p>
          </div>
          <button className="congratulatory-close-button" onClick={onClose}>
            Close
          </button>
        </div>
      </SpotlightCard>
    </div>
  );
};

export default CongratulatoryNotification;